import { Component } from '@angular/core';
import { HomepageService } from 'src/app/user/dashboard/homepage.service';

@Component({
  selector: 'app-dashboardpersonaoperationsgeneral',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class DashboardPersonaOperationsGeneralComponent {
  public defaultColumns = [
    { name: 'status' },
    { name: 'identificationCodeMnemonic' },
    { name: 'operationsManager' },
    { name: 'dateStart' },
    { name: 'dateEnd' },
    { name: 'personaName' },
    { name: 'crmSku' },
    { name: 'factory' },
    { name: 'specialization' },
    { name: 'updated' }
  ];
  public columnsToExclude = ['identifier'];
  public columnsNotToFilter = ['updated', 'status', 'createdAt'];
  constructor(public homepageService: HomepageService) { }
}
